import { useState } from 'react';

interface UseFormProps {
  selectedObj: any;
}

export const useForm = ({ selectedObj }: UseFormProps) => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [formMode, setFormMode] = useState<'add' | 'edit' | 'view'>('add');
  const [isCopyMode, setIsCopyMode] = useState<boolean>(false);

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
  };

  const handleAddClick = () => {
    setFormMode('add');
    setIsCopyMode(false);
    setShowForm(true);
  };

  const handleEditClick = () => {
    setFormMode('edit');
    setShowForm(true);
  };

  const handleDeleteClick = () => {
    setShowDelete(true);
  };

  const handleShowDetail = () => {
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
  };

  return {
    showForm,
    showDelete,
    showDetail,
    formMode,
    selectedObj,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleDeleteClick,
    handleCloseDetail,
    handleShowDetail
  };
};
